import '../bin/pixi-spine';

PIXI.glCore.VertexArrayObject.FORCE_NATIVE = true;

import Ticker from '../Ticker';
import Sprite from './Sprite';

var stateEvents = [
    "start",
    "interrupt",
    "end",
    "dispose",
    "complete",
    "event"
];

/**
 * @description Спрайт для отображения анимаций Spine
 * @memberOf module:display
 * @augments module:display.Sprite
 * @example let view = new SpineSprite(spineData);
 */
class SpineSprite extends Sprite {

    /**
     * @param skeletonData подготовленные данные Spine
     */
    constructor(skeletonData) {

        super();

        if (!skeletonData) throw Error("SpineSprite requires prepared skeleton data");

        let view = new PIXI.spine.Spine(skeletonData);

        view.skeleton.setToSetupPose();
        view.autoUpdate = false;

        this.addChild(view);

        /**
         * Внешнее представление анимации Spine
         * @type {PIXI.spine.Spine}
         */
        this.view = view;

        Ticker.on('tick', this.tick, this);
    }

    safeRemove() {
        Ticker.off('tick', this.tick, this);
        super.safeRemove();
    }

    on(event, fn, context) {
        if (stateEvents.indexOf(event) >= 0) {
            var data = {};
            data[event] = fn;
            this.view.state.addListener(data);

            if (context) {
                console.warn("Spine state does not support context for listeners");
            }
            return;
        }

        super.on(event, fn, context);
    }

    once(event, fn, context) {
        if (stateEvents.indexOf(event) >= 0) {
            throw Error("Spine state does not support once listeners");
            return;
        }

        super.once(event, fn, context);
    }

    removeListener(event, fn, context, once) {
        if (stateEvents.indexOf(event) >= 0) {
            if (context) {
                console.warn("Spine state does not support context for listeners");
            }

            if (once) {
                throw Error("Spine state does not support once listeners");
            }

            var data = {};
            data[event] = fn;
            this.view.state.removeListener(data);

            return;
        }

        super.removeListener(event, fn, context, once);
    }

    off(event, fn, context, once) {
        this.removeListener(event, fn, context, once);
    }

    removeAllListeners() {
        super.removeAllListeners();
        this.view.state.clearListeners();
    }

    /**
     * Установка анимации по имени
     * @param trackIndex
     * @param animationName
     * @param loop
     */
    setAnimationByName(trackIndex, animationName, loop) {
        this.view.state.setAnimation(trackIndex, animationName, loop);
        this.view.update(0);
    }

    tick(e) {
        if (this.playing) {
            this.view.update(e.delta / 1000);
        }
    }
}

export default SpineSprite;
